import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { post } from 'axios';
import { MDBRow, MDBCol } from 'mdbreact';

import FilledButton from 'components/Buttons/FilledButton';

import Divider from 'components/FormGroup/Divider';
import Textarea from 'components/FormGroup/Textarea';
import SelectField from 'components/FormGroup/SelectField';
import ErrorMessage from 'components/FormGroup/ErrorMessage';

import useFetch from 'hooks/useFetch';
import endpoints from 'services/endpoints';
import { FormatCurrency } from 'utils/core';
import { formatDate } from 'utils/moment';

import * as S from './styles';

const { refundsCategoryTypes, getApproveStatus } = endpoints;

export default function RefundsActions({
  paymentsData,
  renderToast,
  reload,
  clearModal,
  approveEndpoint,
}) {
  const { userID, modalData } = paymentsData;
  const [action, setAction] = useState();
  const [refundsCategories] = useFetch(refundsCategoryTypes);
  const [optionsStatus] = useFetch(getApproveStatus);
  const [approveStatus, setApproveStatus] = useState([]);
  const initialValues = {
    id_usr_up: userID || '',
    data_aprovacao: formatDate(new Date(), 'YYYY-MM-DD 00:00:00'),
    id_aprovacao: modalData ? modalData.id_aprovacao_gestor : '',
    justificativa: '',
    id_reembolso: modalData ? modalData.id_reembolso : '',
  };

  const validationSchema = Yup.object().shape({
    id_usr_up: Yup.number().nullable(),
    data_aprovacao: Yup.string().nullable(),
    id_aprovacao: Yup.number().required('Selecione uma resposta'),
    justificativa:
      action === 3
        ? Yup.string()
            .required('Insira o motivo da negativa')
            .min(10, 'São necessários no mínimo 10 caracteres')
            .max(255, 'Número máximo de 255 caracteres excedido')
        : Yup.string().nullable(),
    id_reembolso: Yup.number().nullable(),
  });

  const validateForm = values =>
    values.id_aprovacao_gestor === 1 ||
    values.id_aprovacao_gestor === null ||
    (values.id_aprovacao_gestor === 2 &&
      (!values.justificativa ||
        (values.justificativa && values.justificativa.length < 10)));

  const submitForm = values => {
    const {
      initialValues: initial,
      justificativa,
      id_aprovacao: approveId,
    } = values;

    const sendData = {
      ...initial,
      justificativa: justificativa && approveId === 3 ? justificativa : null,
      id_aprovacao: approveId,
    };

    post(approveEndpoint, sendData)
      .then(() => renderToast('success', 'Status alterado com sucesso', 4000))
      // eslint-disable-next-line no-return-await
      .then(async () => await reload(prev => !prev))
      .then(() => clearModal())
      .catch(() => {
        renderToast(
          'error',
          'Não foi possivel prosseguir com a ação. Por favor, tente novamente',
          5000,
        );
        clearModal();
      });
  };

  const showMoreInfo = (itens, valor) => {
    const total = itens.map(i => ({ total: i.quantidade * i.valor_unitario }));
    return (
      <S.MoreActionsIncoContainer>
        {FormatCurrency(valor)}
        {!!itens.length && (
          <S.ProjectMore>
            <S.MoreActionsIcon
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 256 256"
            >
              <path
                d=" M -1 128 C -1.01 110.76 2.44 93.69 9.15 77.81 C 15.64 62.48 25.03 48.56 36.8 36.8 C 48.56 25.03 62.48 15.64 77.8 9.15 C 93.69 2.44 110.76 -1.01 128 -1 C 145.24 -1.01 162.31 2.44 178.2 9.15 C 193.52 15.64 207.44 25.03 219.2 36.8 C 230.97 48.56 240.36 62.48 246.85 77.8 C 253.56 93.69 257.01 110.76 257 128 C 257.01 145.24 253.56 162.31 246.85 178.2 C 240.36 193.52 230.97 207.44 219.2 219.2 C 207.44 230.97 193.52 240.36 178.2 246.85 C 162.31 253.56 145.24 257.01 128 257 C 110.76 257.01 93.69 253.56 77.8 246.85 C 62.48 240.36 48.56 230.97 36.8 219.2 C 25.03 207.44 15.64 193.52 9.15 178.2 C 2.44 162.31 -1.01 145.24 -1 128 Z  M 15 128 C 14.99 112.9 18.01 97.95 23.88 84.03 C 29.57 70.62 37.8 58.42 48.11 48.11 C 58.42 37.8 70.62 29.57 84.04 23.88 C 97.95 18.01 112.9 14.99 128 15 C 143.1 14.99 158.05 18.01 171.96 23.88 C 185.38 29.57 197.58 37.8 207.89 48.11 C 218.2 58.42 226.43 70.62 232.12 84.04 C 237.99 97.95 241.01 112.9 241 128 C 241.01 143.1 237.99 158.05 232.12 171.96 C 226.43 185.38 218.2 197.58 207.89 207.89 C 197.58 218.2 185.38 226.43 171.96 232.12 C 158.05 237.99 143.1 241.01 128 241 C 112.9 241.01 97.95 237.99 84.04 232.12 C 70.62 226.43 58.42 218.2 48.11 207.89 C 37.8 197.58 29.57 185.38 23.88 171.96 C 18.01 158.05 14.99 143.1 15 128 Z  M 115.5 118.625 L 140.5 118.625 L 140.5 187.377 L 115.5 187.377 L 115.5 118.625 Z  M 112.374 84.249 C 112.374 75.625 119.376 68.623 128 68.623 C 136.624 68.623 143.626 75.625 143.626 84.249 C 143.626 92.873 136.624 99.874 128 99.874 C 119.376 99.874 112.374 92.873 112.374 84.249 Z "
                fillRule="evenodd"
              />
            </S.MoreActionsIcon>
            <S.MoreActions>
              <S.MoreActionsHeader>Mais informações</S.MoreActionsHeader>
              {refundsCategories && (
                <S.MoreActionsTable>
                  <S.MoreActionsTableHeader>
                    <div>Categoria</div>
                    <div>Qtd.</div>
                    <div>Valor Unit.</div>
                    <div>Total</div>
                  </S.MoreActionsTableHeader>
                  {itens.map((item, k) => {
                    const category = refundsCategories.find(
                      c => c.value === item.id_tipo_reembolso,
                    );
                    return (
                      category && (
                        <S.MoreActionsInfo key={item.id_item_reembolso}>
                          <S.InfoStrong>{category.label}</S.InfoStrong>
                          <S.InfoSpan>{item.quantidade}</S.InfoSpan>
                          <S.InfoSpan>
                            {FormatCurrency(item.valor_unitario)}
                          </S.InfoSpan>
                          <S.InfoSpan>
                            {FormatCurrency(total[k].total)}
                          </S.InfoSpan>
                        </S.MoreActionsInfo>
                      )
                    );
                  })}
                </S.MoreActionsTable>
              )}
            </S.MoreActions>
          </S.ProjectMore>
        )}
      </S.MoreActionsIncoContainer>
    );
  };

  useEffect(() => {
    (async () => {
      const response = await optionsStatus
        .filter(({ id_aprovacao }) => id_aprovacao > 2)
        .map(status => ({
          label: status.aprovacao,
          value: status.id_aprovacao,
        }));
      setApproveStatus(response);
    })();

    const unMount = () => {
      setApproveStatus([]);
    };

    return unMount;
  }, [optionsStatus]);

  return (
    <S.ModalWrap>
      <S.ModalContainer>
        <MDBRow>
          <MDBCol>
            <Divider text="Detalhes da solicitação" hasTopSpacing={false} />
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <S.ModalBody>
              <S.ColWrap>
                <S.FakeLabel>Funcionario: </S.FakeLabel>
                <S.InfoText>{modalData.nome_funcionario}</S.InfoText>
              </S.ColWrap>
              <S.ColWrap />
              <S.ColWrap>
                <S.FakeLabel>Projeto: </S.FakeLabel>
                <S.InfoText>{modalData.nome_projeto}</S.InfoText>
              </S.ColWrap>
              <S.ColWrap>
                <S.FakeLabel>Total: </S.FakeLabel>
                <S.InfoText>
                  {showMoreInfo(modalData.itens, modalData.valor_total)}
                </S.InfoText>
              </S.ColWrap>
              <S.ColFullWrap>
                <S.FakeLabel>Mais informações: </S.FakeLabel>
                <S.InfoText>{modalData.detalhamento}</S.InfoText>
              </S.ColFullWrap>
            </S.ModalBody>
          </MDBCol>
        </MDBRow>
        {modalData.id_aprovacao_gestor === 1 ||
        modalData.id_aprovacao_gestor === 4 ? (
          <Formik
            initialValues={{ initialValues }}
            enableReinitialize
            validateOnBlur={false}
            validateOnChange={false}
            validationSchema={validationSchema}
            onSubmit={e => submitForm(e)}
          >
            {({
              values,
              errors,
              handleSubmit,
              setFieldValue,
              isSubmitting,
            }) => (
              <form onSubmit={e => submitForm(e)}>
                {errors && errors.justificativa && (
                  <ErrorMessage message={errors.justificativa} />
                )}
                {errors && errors.id_aprovacao && (
                  <ErrorMessage message={errors.id_aprovacao} />
                )}
                <MDBRow>
                  <MDBCol>
                    <SelectField
                      name="id_aprovacao"
                      className="w-100"
                      labelText="Deseja aprovar esta solicitação ?"
                      value={approveStatus.find(
                        opt => opt.value === values.id_aprovacao,
                      )}
                      options={approveStatus}
                      handleChange={e => {
                        setFieldValue('id_aprovacao', e.value);
                      }}
                      menuPlacement="top"
                    />
                  </MDBCol>
                </MDBRow>
                {values.id_aprovacao === 3 && (
                  <MDBRow>
                    <MDBCol>
                      <Textarea
                        name="justificativa"
                        labelText="Motivo da negativa"
                        value={values.justificativa}
                        handleChange={e => {
                          setFieldValue('justificativa', e.target.value);
                          setAction(e.target.value);
                        }}
                      />
                    </MDBCol>
                  </MDBRow>
                )}
                <MDBRow>
                  <MDBCol>
                    <S.ModalButtonsWrap>
                      <FilledButton
                        buttonClass="cancel"
                        text="Cancelar"
                        handleClick={clearModal}
                      />
                      <FilledButton
                        buttonClass="confirm"
                        text="confirmar"
                        buttonType="submit"
                        handleClick={handleSubmit}
                        disabled={isSubmitting || validateForm(values)}
                      />
                    </S.ModalButtonsWrap>
                  </MDBCol>
                </MDBRow>
              </form>
            )}
          </Formik>
        ) : (
          <MDBRow>
            <MDBCol>
              {modalData.id_aprovacao_gestor === 2 ? (
                <S.ModalAlert type="success">Reembolso aprovado</S.ModalAlert>
              ) : modalData.id_aprovacao_gestor === 5 ? (
                <S.ModalAlert type="success">
                  Enviado para Faturamento
                </S.ModalAlert>
              ) : (
                <S.ModalAlert type="danger">
                  Reembolso não aprovado
                </S.ModalAlert>
              )}
              <S.ModalButtonsWrap>
                <FilledButton
                  buttonClass="cancel"
                  text="Cancelar"
                  handleClick={clearModal}
                />
              </S.ModalButtonsWrap>
            </MDBCol>
          </MDBRow>
        )}
      </S.ModalContainer>
    </S.ModalWrap>
  );
}

RefundsActions.propTypes = {
  paymentsData: PropTypes.shape({
    userID: PropTypes.number.isRequired,
    modalData: PropTypes.shape(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    ).isRequired,
  }).isRequired,
  renderToast: PropTypes.func.isRequired,
  clearModal: PropTypes.func.isRequired,
  reload: PropTypes.func.isRequired,
  approveEndpoint: PropTypes.string.isRequired,
};
